import { useContext } from 'react'
import { AppToastContext } from './AppToastProvider'

export const useAppToast = () => {
  const context = useContext(AppToastContext)
  if (!context) throw new Error('useAppToast must be used within AppToastProvider.')
  return context
}
